import { Component, Input, OnInit } from '@angular/core';
import { dialogConfig } from '@modals/dialog.configure';
import { MbDialog, MbButton } from '@am/moebius';
import { ModalModifySearchComponent } from '@modals/modify-search/modify-search.component';

@Component({
    selector: 'modify-search',
    templateUrl: './modify-search.component.html',
    styleUrls: ['./modify-search.component.scss'],
    standalone: true,
    imports: [MbButton],
})
export class ModifySearchComponent implements OnInit {
  @Input()
  buttonType: string;
  @Input()
  modify: boolean;
  @Input()
  hotelStatic: any;

  public searching: boolean;

  constructor(private dialog: MbDialog) {}

  ngOnInit() {
    this.searching = false;
  }

  /**
   * Toggles the re search modal
   */
  public toggleModal() {
    if (!this.dialog.isAnyDialogOpen) {
      const dialogData = {
        hotelStatic: this.hotelStatic,
        searching: this.searching,
      };
      this.dialog.open(ModalModifySearchComponent, {
        ...dialogConfig,
        dialogData: dialogData,
        closeBtn: true,
        size: 'lg',
      });
    }
  }
}
